module.exports = __webpack_public_path__ + "img/jeux enfant.57f5549c.jpeg";